import { Controller } from "@hotwired/stimulus";

export default class WistiaModalController extends Controller {
  static targets = ["header"];
  static values = { videoId: String };

  connect() {
    this.respectCookieConsent();
    App.cookieConsentStore?.subscribe(() => this.respectCookieConsent());
  }

  respectCookieConsent() {
    if (App.cookieConsentStore?.read().evaluation_enabled) {
      this.element.classList.remove("force-hidden");
    } else {
      this.element.classList.add("force-hidden");
    }
  }

  preload() {
    this.loadJS(`https://fast.wistia.com/embed/medias/${this.videoIdValue}.jsonp`);
    this.loadJS("https://fast.wistia.com/assets/external/E-v1.js");
  }

  open() {
    this.preload();

    window._wq = window._wq || [];
    _wq.push({
      id: this.videoIdValue,
      onReady(video) {
        video.play();

        // Some browsers (e.g. Safari) won't autoplay videos. In that case, Wistia doesn't open the popover,
        // so we need to show it manually, just to be sure.
        video.popover.show();
      },
    });
  }

  loadJS(url) {
    if (document.querySelector(`script[src="${url}"]`)) return;

    const script = document.createElement("script");
    script.src = url;
    script.async = true;
    document.head.appendChild(script);
  }
}
